import ToastNotification from './Toast';
import styled from 'styled-components';

const ToastsContainer = styled.div`
  position: fixed;
  top: 20px;
  right: 20px;
  z-index: 9999;
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

const ToastManager = ({ toasts, removeToast }) => {
  return (
    <ToastsContainer>
      {toasts.map(toast => (
        <ToastNotification
          key={toast.id}
          message={toast.message}
          type={toast.type}
          duration={toast.duration}
          onClose={() => removeToast(toast.id)}
        />
      ))}
    </ToastsContainer>
  );
};

export default ToastManager;